import type {FC} from "react"

import {Anchor} from "components/Anchor"

import LogoIcon from "public/icons/logo.svg"

import type {UserHeaderProps} from "./UserHeader"
import {UserHeader} from "./UserHeader"

export const UserHeaderWithLogo: FC<UserHeaderProps> = props => (
  <UserHeader {...props}>
    <Anchor href="/dashboard">
      <LogoIcon />
    </Anchor>
  </UserHeader>
)
